module.exports = __webpack_public_path__ + "img/q25.80b52bee.png";